import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import { BaseURL,  uniqueToken } from "../../api/DataApis";
import {GpsBaseURL, Role} from "../../api/DataApis";
import axios from "axios";
import Select from 'react-select';


function Add() {
  document.title = "Product | Add";
  let navigate = useNavigate();

console.log("Role:", Role);
  // State variables
  const [Title, setTitle] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [Price, setPrice] = useState("");
  const [Stock, setStock] = useState("");
  const [IsFeatured, setIsFeatured] =  useState("");
  const [loading, setLoading] = useState(false);
  const [Description, setDescription] =  useState("");
 

  const handleTitleChange = (e) => setTitle(e.target.value);
  const handlePriceChange = (e) => setPrice(e.target.value);
  const handleStockChange = (e)   => setStock(e.target.value);
  const handleFeaturedChange =  (e) =>  setIsFeatured(e.target.value);
  const handleDescriptionChange =  (e) =>  setDescription(e.target.value);

  // Function to handle the update request
  const AddUser = async () => {
    // Show loader before API call
    Swal.fire({
      title: 'Adding Product ...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    // Create a new FormData object
    let formData = new FormData();
    formData.append("title", Title);
    formData.append("price", Price);
    formData.append("stock", Stock);
    formData.append("is_featured", IsFeatured);
    formData.append("description", Description);
  

 
    try {
      // Make the API request
      let response = await axios.post(
        `${GpsBaseURL}/product`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
            // 'Content-Type' is automatically set by axios when using FormData
          },
        }
      );
  
      // Hide the loader
      Swal.close();
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response?.data?.message,
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/product-list`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to add  product. Status: ${response.data.statusCode}`,
        });
      }
    } catch (error) {
      // Hide the loader
      Swal.close();
  
      console.error("Error in AddUser:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };
  
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Add Product
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="name_id" className="col-sm-2 control-label">
                          Title
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleTitleChange}
                                value={Title}
                                className="form-control"
                                id="name_id"
                                name="station_name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                   

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Enter Price
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="price"
                                onChange={handlePriceChange}
                                className="form-control"
                                id="price"
                                name="price"
                                value={Price}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                          Stock
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="stock"
                                onChange={handleStockChange}
                                className="form-control"
                                id="stock"
                                name="stock"
                                value={Stock}
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              IsFeatured
                            </label>
                            <div className="col-sm-6">
                              <select
                              type="text"
                                onChange={handleFeaturedChange}
                                className="form-control"
                                id="text"
                                name="text"
                                value={IsFeatured}
                              
                              >
                                <option value= "Yes">Yes</option>
                                <option value= "No">No</option>
                                </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Description
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="text"
                                onChange={handleDescriptionChange}
                                className="form-control"
                                id=""
                                name=""
                                value={Description}
                                autoComplete="off"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                    
                   
                          <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={AddUser}
                              value="Add Product"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Add;
